import { z } from 'zod'

export const MemberAccessStatusSchema = z.enum(['ACTIVE', 'PAST_DUE', 'EXPIRED', 'REVOKED'])
export const MemberGrantOriginSchema = z.enum([
  'SALE',
  'ORDER_BUMP',
  'UPSELL',
  'SUBSCRIPTION',
  'MANUAL',
])
export const MemberRevocationReasonSchema = z.enum([
  'REFUND',
  'CHARGEBACK',
  'SUBSCRIPTION_CANCELED',
  'MANUAL',
])
export const MemberTimelineKindSchema = z.enum([
  'GRANTED',
  'REVOKED',
  'RESTORED',
  'EXPIRED',
  'PAST_DUE',
])

export const MembersListItemSchema = z.object({
  id: z.string(),
  name: z.string(),
  email: z.string(),
  accessStatus: MemberAccessStatusSchema,
  revocationReason: MemberRevocationReasonSchema.nullable(),
  origin: MemberGrantOriginSchema,
  productNames: z.array(z.string()),
  enrolledAt: z.string(),
})

export const MembersListSchema = z.object({
  items: z.array(MembersListItemSchema),
  nextCursor: z.string().nullable(),
  activeCount: z.number(),
})

export const MemberGrantSchema = z.object({
  id: z.string(),
  productId: z.string(),
  productName: z.string(),
  origin: MemberGrantOriginSchema,
  status: MemberAccessStatusSchema,
  revocationReason: MemberRevocationReasonSchema.nullable(),
  accessUntil: z.string().nullable(),
  grantedAt: z.string(),
  canRevoke: z.boolean(),
  canRestore: z.boolean(),
})

export const MemberTimelineEventSchema = z.object({
  id: z.string(),
  kind: MemberTimelineKindSchema,
  description: z.string(),
  occurredAt: z.string(),
})

export const MemberDetailSchema = z.object({
  id: z.string(),
  name: z.string(),
  email: z.string(),
  accessStatus: MemberAccessStatusSchema,
  enrolledAt: z.string(),
  grants: z.array(MemberGrantSchema),
  timeline: z.array(MemberTimelineEventSchema),
})

export const CourtesyInputSchema = z.object({
  email: z.string().email(),
  name: z.string().min(1),
  productId: z.string().min(1),
  accessUntil: z.string().optional(),
})

export type MemberAccessStatus = z.infer<typeof MemberAccessStatusSchema>
export type MemberGrantOrigin = z.infer<typeof MemberGrantOriginSchema>
export type MemberRevocationReason = z.infer<typeof MemberRevocationReasonSchema>
export type MemberTimelineKind = z.infer<typeof MemberTimelineKindSchema>
export type MembersListItem = z.infer<typeof MembersListItemSchema>
export type MembersList = z.infer<typeof MembersListSchema>
export type MemberGrant = z.infer<typeof MemberGrantSchema>
export type MemberTimelineEvent = z.infer<typeof MemberTimelineEventSchema>
export type MemberDetail = z.infer<typeof MemberDetailSchema>
export type CourtesyInput = z.infer<typeof CourtesyInputSchema>
